import { render, staticRenderFns } from "./Stdpatient.vue?vue&type=template&id=7607323f&scoped=true&"
import script from "./Stdpatient.vue?vue&type=script&lang=js&"
export * from "./Stdpatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7607323f",
  null
  
)

export default component.exports